import { mapGetters, mapState } from 'vuex'

export default {
    props: {
        patients: {
            type: Array
        },
        events: {
            type: Array
        }
    },

    methods: {
        addRow() {
            this.patients.push({
                data: {
                    name: '',
                    email: '',
                    phone: '',
                    provider: '',
                    profile: '',
                    schedule: []
                }
            })
        },
        removeRow(index) {
            this.patients.splice(index, 1)
        }
    },

    computed: {
        ...mapGetters('provider', [
			'getProviderList',
        ]),
        activeColumns() {
            return {
                provider: this.getProviderList.length > 1,
                profile: this.getProviderList.some((provider) => provider.profile.length > 1)
            }
        }
    }
}
